export class TermsAndConditionsResponseDTO{
    privacyContent!: string;
    termsContent!: string;

    constructor(data: TermsAndConditionsResponseDTO){
        Object.assign(this, data);
    }
}